module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-0-7763f253b9a8a569cd1284f345956609.jpg";